import { Element, Elements, ElementIds, Parents, TotalProgress } from 'types';

const PATTERN = /[0-9]{1,2}_/;

export function sortDlc(father: Element['id'], mother: Element['id']): Parents {
  if (PATTERN.test(father) && PATTERN.test(mother)) {
    const fatherId = father.replace(PATTERN, '');
    const motherId = mother.replace(PATTERN, '');

    if (+motherId < +fatherId) {
      return [mother, father];
    }

    return [father, mother];
  }

  if (PATTERN.test(father)) {
    return [mother, father];
  }

  return [father, mother];
}

export function sortStandard(father: Element['id'], mother: Element['id']): Parents {
  return [`${ Math.min(+father, +mother) }`, `${ Math.max(+father, +mother) }`];
}

export function sortParents([father, mother]: Parents): Parents {
  if (PATTERN.test(father) || PATTERN.test(mother)) {
    return sortDlc(father, mother);
  }

  return sortStandard(father, mother);
}

export function sortAlphabetically(elements: Elements, ids: ElementIds, reverse = false): ElementIds {
  const names: string[] = [];
  const idMap: { [name: string]: Element['id'] } = {};
  ids.forEach((id) => {
    if (!elements.hasOwnProperty(id)) return;

    const name = `${ elements[id].name.toLowerCase() }_${ id }`;
    idMap[name] = id;
    names.push(name);
  });

  const sorted = names.sort();
  const result = sorted.map((name) => idMap[name]);
  if (reverse) {
    return result.reverse();
  }

  return result;
}

export function sortChronologically(timestamps: Record<string, number>, ids: ElementIds, reverse = false): ElementIds {
  const sorted = ids.sort((a, b) => {
    const t1 = timestamps[a] || -1;
    const t2 = timestamps[b] || -1;

    if (t1 > t2) return -1;
    if (t1 < t2) return 1;
    return 0;
  });

  if (reverse) {
    return sorted.reverse();
  }

  return sorted;
}

export function sortChronologicallyFromList(totalList: TotalProgress, ids: ElementIds, reverse = false): ElementIds {
  const timestamps = totalList.reduce((result, { id, timestamp }) => {
    result[id] = timestamp;
    return result;
  }, {} as Record<Element['id'], number>);

  return sortChronologically(timestamps, ids, reverse);
}
